import { Avatar } from "shared/components/atoms/Avatar";
import { HTMLRenderer } from "shared/components/atoms/HTMLRenderer";
import { StarRating } from "shared/components/molecules/StarRating";
import { StatusLabel } from "shared/components/molecules/StatusLabel";
import { FortuneTeller } from "shared/types";
import { zIndex } from "shared/styles";
import { styled } from "twin.macro";
import { Paths } from "utils/routes";
import Link from "next/link";
import { removeHtmlTags } from "shared/utils";

const Rank = styled.div`
  width: 31px;
  height: 31px;
  border-radius: 16px;
  background: linear-gradient(
    -44deg,
    rgba(168, 79, 178, 8),
    rgba(230, 138, 180, 8)
  );
  opacity: 0.8;
  position: absolute;
  top: -4px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ヒラギノ角ゴシック;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.47px;
  color: #fff;
  z-index: ${zIndex.priority};
`;

interface Props {
  fortuneTeller: FortuneTeller;
  ranking?: number;
}

export const FortuneTellerListItem = ({ fortuneTeller, ranking }: Props) => {
  const {
    id,
    imageUrl,
    thumbnailUrl,
    name,
    averageScore,
    reviewCounts,
    selfIntroduction,
  } = fortuneTeller;

  return (
    <Link href={Paths.fortuneTellers.show(id)} passHref>
      <a tw="flex flex-col items-center py-4 px-2 w-full text-center cursor-pointer">
        <div tw="relative">
          {ranking && <Rank>{ranking}</Rank>}
          <Avatar src={imageUrl} fallback={thumbnailUrl} size={119} />
        </div>
        <div tw="w-full h-8 flex items-end">
          <HTMLRenderer tw="font-semibold text-base leading-none tracking-[.47px] text-black truncate">
            {name}
          </HTMLRenderer>
        </div>
        <StatusLabel tw="mt-3" fortuneTeller={fortuneTeller} />
        <div tw="flex items-center mt-[5px]">
          <StarRating rate={averageScore} size="large" />
          <div tw="font-light text-xs tracking-[.3px] text-secondary ml-0.5">
            ({reviewCounts})
          </div>
        </div>
        <p tw="text-black font-normal text-2xs tracking-[.29px] leading-[16px] text-center mt-[5px] line-clamp-2">
          {removeHtmlTags(selfIntroduction)}
        </p>
      </a>
    </Link>
  );
};
